import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { RouterLink } from "@angular/router";
import { ContentDesktopButtonTooltipDirective } from "../../tooltip/content-desktop-button-tooltip.directive";
import {ClientSideRenderingDirective} from '../../../../../../../common/directives/client-side-rendering.directive';

@Component({
  selector: 'ra-user-space-btn',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    OverlayPanelModule,
    RouterLink,
    ContentDesktopButtonTooltipDirective,
    ClientSideRenderingDirective,
  ],
  template: `
    <button
      raContentDesktopButtonTooltip
      [buttonActive]="active"
      [class.h-button-primary]="idleColor === 'primary' && !active"
      [class.h-button-transparent]="idleColor === 'transparent' && !active"
      [class.h-button-active]="active"
      [title]="tooltipText"
      [tooltipText]="tooltipText"
      *clientSideRendering
      pButton
      class="p-button-square-s p-button-secondary"
    >
      <ng-content></ng-content>
    </button>
  `,
  styles: `
    :host {
        @apply relative;
    }
  `,
})
export class UserSpaceBtnComponent {
  @Input({ required: true }) tooltipText!: string;
  @Input({ required: true }) idleColor!: 'primary' | 'transparent';
  @Input() active = false;
}
